export const JT_MEETING_APP = "jtMeetings"
export const MESSAGE_SENT_EVENT = "messageSent"

export const OmitNotificationApps = new Set<string>([
  JT_MEETING_APP
])

export const shouldOmitNotification = (sourceApp?: string) =>
  sourceApp ? OmitNotificationApps.has(sourceApp) : false
